var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { DATES_BOOKING_STEPS_STATE } from '@ibe.components/booking/booking.setup';
import { BookedTrip } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { TAPDataStorageService } from '@ibe/services/mocks.tap';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { environment } from '@environments/environment';
var BookingStepsEffect = /** @class */ (function () {
    function BookingStepsEffect(store, router, storage) {
        this.store = store;
        this.router = router;
        this.storage = storage;
        this.store.dispatch(new BookingStepsActions.LoadingAction);
        this.storage.initializeBookingsIfEmpty();
        moment.locale(environment.locale);
    }
    /**
     * Create booking steps based on formValue
     * Create booking Trip empty
     * @param formValue
     */
    BookingStepsEffect.prototype.createBookingSteps = function (formValue, discounts, dates) {
        if (discounts === void 0) { discounts = null; }
        if (dates === void 0) { dates = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var bookedTrip, steps, stopover, inbound, outbound, outbound, outbound, stopover_1, payload, passengers, i, i, i, i;
                        return __generator(this, function (_a) {
                            bookedTrip = new BookedTrip([], 'PNRXXX', 'R');
                            steps = [];
                            switch (formValue.routeType) {
                                case 'R':
                                    if (formValue.stopovers && formValue.stopovers.length) {
                                        if (formValue.stopovers.length > 2) {
                                            formValue.stopovers.splice(0, 1);
                                        }
                                        stopover = { inbound: null, outbound: null };
                                        inbound = formValue.stopovers.find(function (cur) { return cur.when == 'inbound'; });
                                        outbound = formValue.stopovers.find(function (cur) { return cur.when == 'outbound'; });
                                        if (inbound)
                                            stopover.inbound = { days: inbound.days, airport: inbound.city, when: "inbound" };
                                        if (outbound)
                                            stopover.outbound = { days: outbound.days, airport: outbound.city, when: "outbound" };
                                        steps = [];
                                        if (outbound) {
                                            steps.push(new BookingStep(formValue.from, stopover.outbound.airport, moment(formValue.from.date).toDate(), stopover.outbound));
                                            steps.push(new BookingStep(stopover.outbound.airport, formValue.to, moment(formValue.from.date).add(stopover.outbound.days, 'days').toDate()));
                                            if (!inbound)
                                                steps.push(new BookingStep(formValue.to, formValue.from, moment(formValue.to.date).toDate(), stopover.inbound));
                                        }
                                        if (inbound) {
                                            if (!outbound)
                                                steps.push(new BookingStep(formValue.from, formValue.to, moment(formValue.from.date).toDate(), stopover.outbound));
                                            steps.push(new BookingStep(formValue.to, stopover.inbound.airport, moment(formValue.to.date).toDate(), stopover.inbound));
                                            steps.push(new BookingStep(stopover.inbound.airport, formValue.from, moment(formValue.to.date).add(stopover.inbound.days, 'days').toDate()));
                                        }
                                        bookedTrip.setStopover(true);
                                    }
                                    else {
                                        if (dates && dates.length > 0) {
                                            steps = [new BookingStep(formValue.from, formValue.to, dates[0]), new BookingStep(formValue.to, formValue.from, dates[1])];
                                        }
                                        else {
                                            steps = [new BookingStep(formValue.from, formValue.to), new BookingStep(formValue.to, formValue.from)];
                                        }
                                    }
                                    break;
                                case 'O':
                                    if (formValue.stopovers && formValue.stopovers.length) {
                                        outbound = formValue.stopovers.find(function (cur) { return cur.when == 'outbound'; });
                                        steps = [
                                            new BookingStep(formValue.from, outbound.city, moment(formValue.from.date).toDate(), { days: outbound.days, airport: outbound.city, when: "outbound" }),
                                            new BookingStep(outbound.city, formValue.to, moment(formValue.from.date).add(outbound.days, 'days').toDate()),
                                        ];
                                        bookedTrip.setStopover(true);
                                    }
                                    else {
                                        if (dates && dates.length > 0) {
                                            steps = [new BookingStep(formValue.from, formValue.to, dates[0])];
                                        }
                                        else {
                                            steps = [new BookingStep(formValue.from, formValue.to, null)];
                                        }
                                    }
                                    break;
                                case 'M':
                                    if (formValue.stopovers && formValue.stopovers.length) {
                                        outbound = formValue.stopovers.find(function (cur) { return cur.when && cur.when.includes('outbound'); });
                                        stopover_1 = { inbound: null, outbound: null };
                                        if (outbound)
                                            stopover_1.outbound = { days: outbound.days, airport: outbound.city, when: outbound.when };
                                        steps = formValue.flights.reduce(function (acc, flight, idx) {
                                            var ckStopover = formValue.stopovers.find(function (c) { return c.when && c.when.includes(flight.from.code + "-" + flight.to.code); });
                                            if (ckStopover) {
                                                if (idx == 0) {
                                                    acc.push(new BookingStep(flight.from, stopover_1.outbound.airport, moment(flight.date.date.year + "-" + flight.date.date.month + "-" + flight.date.date.day, 'YYYY-M-D').toDate(), stopover_1.outbound));
                                                    acc.push(new BookingStep(stopover_1.outbound.airport, flight.to, moment(flight.from.date).add(stopover_1.outbound.days, 'days').toDate()));
                                                }
                                                else {
                                                    acc.push(new BookingStep(flight.from, stopover_1.outbound.airport, moment(flight.date.date.year + "-" + flight.date.date.month + "-" + flight.date.date.day, 'YYYY-M-D').toDate(), stopover_1.outbound));
                                                    acc.push(new BookingStep(stopover_1.outbound.airport, flight.to, moment(flight.date.date.year + "-" + flight.date.date.month + "-" + flight.date.date.day).add(stopover_1.outbound.days, 'days').toDate()));
                                                }
                                            }
                                            else {
                                                acc.push(new BookingStep(flight.from, flight.to, moment(flight.date.date.year + "-" + flight.date.date.month + "-" + flight.date.date.day, 'YYYY-M-D').toDate()));
                                            }
                                            return acc;
                                        }, []);
                                        bookedTrip.setStopover(true);
                                    }
                                    else {
                                        steps = formValue.flights.map(function (cur) {
                                            return new BookingStep(cur.from, cur.to, (cur.date ? moment(cur.date.date.year + "-" + cur.date.date.month + "-" + cur.date.date.day, 'YYYY-M-D').toDate() : null));
                                        });
                                    }
                                    break;
                                default:
                                    steps = DATES_BOOKING_STEPS_STATE;
                                    break;
                            }
                            payload = {
                                current_step: 0,
                                booking_steps: steps,
                                booking_type: formValue.routeType
                            };
                            passengers = formValue.passengers;
                            bookedTrip.passengers = passengers;
                            bookedTrip.emptyPassengers();
                            bookedTrip.emptyFlights();
                            if (passengers.adults && passengers.adults > 0) {
                                for (i = 0; i < passengers.adults; i++) {
                                    bookedTrip.addPassenger('adult');
                                }
                            }
                            if (passengers.adults && passengers.youngAdults > 0) {
                                for (i = 0; i < passengers.youngAdults; i++) {
                                    bookedTrip.addPassenger('youngAdult');
                                }
                            }
                            if (passengers.children && passengers.children > 0) {
                                for (i = 0; i < passengers.children; i++) {
                                    bookedTrip.addPassenger('child');
                                }
                            }
                            if (passengers.infants && passengers.infants > 0) {
                                for (i = 0; i < passengers.infants; i++) {
                                    bookedTrip.addPassenger('infant');
                                }
                            }
                            bookedTrip.setType(formValue.routeType);
                            if (discounts)
                                bookedTrip.discounts = discounts;
                            this.store.dispatch(new BookingStepsActions.PutBookingStepsAction(payload));
                            this.store.dispatch(new BookedTripActions.PutBookedTripAction(bookedTrip));
                            resolve();
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    BookingStepsEffect.prototype.getCostsPerDay = function (totalSteps) {
        var allCostsPerDay = [];
        for (var i = 0; i < totalSteps; i++) {
            allCostsPerDay.push(this.storage.generateMockCosts());
        }
        this.store.dispatch(new BookingStepsActions.PutAllCostsPerDayAction(allCostsPerDay));
    };
    BookingStepsEffect.prototype.cancelBookingSteps = function () {
        this.store.dispatch(new BookingStepsActions.PutCurrentPageAction(null));
        this.store.dispatch(new BookingStepsActions.ResetAction());
    };
    BookingStepsEffect.prototype.selectNewDates = function () {
        this.store.dispatch(new BookingStepsActions.ResetSelectedFlightAction);
        this.store.dispatch(new BookingStepsActions.PutBookingStepsAction(0));
    };
    return BookingStepsEffect;
}());
export { BookingStepsEffect };
